import { FunctionComponent, memo } from "react";
import { DetailsSection, DetailsSectionTitle } from "@edgetier/client-components";
import InteractionDetailsAgent from "./interaction-details-agent";
import InteractionDetailsItem from "./interaction-details-item";
import { useInteractionDetails } from "hooks-for/interactions/use-interaction-details";
import InteractionVariablesValues from "./interaction-variables-values";
import { IProps } from "./interaction-details.types";
import "./interaction-details.scss";

/**
 * Any details relevant to the interaction.
 * @param props.agentId The ID of the agent who handled the interaction.
 * @param props.interactionId The ID of the interaction
 */
const InteractionDetails: FunctionComponent<IProps> = ({ agentId, interactionId }) => {
    const { data: interactionDetails, isLoading } = useInteractionDetails(interactionId);

    return (
        <div className="interaction-details">
            <DetailsSection>
                <DetailsSectionTitle title="Interaction Details" />
                <table aria-label="interaction-details">
                    <tbody>
                        <InteractionDetailsAgent agentId={agentId} />
                        <InteractionDetailsItem
                            detailsLabel="Enter Queue Date"
                            value={interactionDetails?.enterQueueDateTime}
                            isInteractionDetailsLoading={isLoading}
                        />
                        <InteractionDetailsItem
                            detailsLabel="Exit Queue Date"
                            value={interactionDetails?.exitQueueDateTime}
                            isInteractionDetailsLoading={isLoading}
                        />
                        <InteractionDetailsItem
                            detailsLabel="Handle Date"
                            value={interactionDetails?.handleDateTime}
                            isInteractionDetailsLoading={isLoading}
                        />
                        <InteractionDetailsItem
                            detailsLabel="Blocked Date"
                            value={interactionDetails?.blockedDateTime}
                            isInteractionDetailsLoading={isLoading}
                        />
                        <InteractionDetailsItem
                            detailsLabel="Sender Name"
                            value={interactionDetails?.senderName}
                            isInteractionDetailsLoading={isLoading}
                        />
                        <InteractionDetailsItem
                            detailsLabel="Sender Email"
                            value={interactionDetails?.senderEmail}
                            isInteractionDetailsLoading={isLoading}
                        />
                    </tbody>
                </table>
                <InteractionVariablesValues interactionId={interactionId} />
            </DetailsSection>
        </div>
    );
};

export default memo(InteractionDetails);
